import { buildSelector } from '@/shared/lib/store';

export const [useViewerProfileData] = buildSelector(
    (state) => state.viewer?.data,
);
